import React from "react";

const RoomsPage = () => (
  <div className="rooms-page">
    <h1>Our Rooms</h1>
    <ul>
      <li>Deluxe Room</li>
      <li>Suite</li>
      <li>Presidential Suite</li>
    </ul>
  </div>
);

export default RoomsPage;
